import { render, staticRenderFns } from "./individualResults.vue?vue&type=template&id=1a570c40&scoped=true&"
import script from "./individualResults.vue?vue&type=script&lang=js&"
export * from "./individualResults.vue?vue&type=script&lang=js&"
import style0 from "./individualResults.vue?vue&type=style&index=0&id=1a570c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a570c40",
  null
  
)

export default component.exports